import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import backgroundAnimation from "../../animations/Animation5.json";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader";
import API from "../../constants/apiConfig";
import "./Phases.css";

const PhaseSelection = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [phases, setPhases] = useState([]);
  const [seenList, setSeenList] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
    const fetchPhases = async () => {
      try {
        const response = await fetch(`${API.GET_LEVELS_AND_DATA}${user.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            arkv: "!$Learn#$!",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setPhases(data.levels || []);
        setSeenList(data.data || []);
      } catch (error) {
        setError(true);
        console.error("Error fetching data:", error);
      } finally {
        setPageLoading(false);
      }
    };

    fetchPhases();
  }, [user]);

  const handlePhaseClick = (phase) => {
    navigate("/levels", {
      state: { levels: phase.level_list, seenList: seenList },
    });
  };

  if (pageLoading) return <Loader />;

  return (
    <div className="main-page">
      <div className="background-animation">
        <Player autoplay loop src={backgroundAnimation} />
      </div>
      <Container className="py-4">
        <Card className="shadow-sm border-0 p-3">
          {error ? (
            <div className="error-card">{"Something went wrong"}</div>
          ) : (
            <>
              <h4 className="text-center mb-4">Select the Phase</h4>
              <Row className="g-3">
                {phases?.map((phase) => (
                  <Col key={phase.video_id} xs={12} sm={6} md={4} lg={3}>
                    <Button
                      variant="success"
                      size="lg"
                      className="w-100 text-truncate"
                      onClick={() => handlePhaseClick(phase)}
                    >
                      {phase.phase_name}
                    </Button>
                  </Col>
                ))}
              </Row>
            </>
          )}
        </Card>
      </Container>
    </div>
  );
};

export default PhaseSelection;
